import gql from 'graphql-tag';

export const getContactByEmail = gql`
  query getContactByEmail($email: String) {
    getContactByEmail(email: $email) {
      id
      firstName
      lastName
    }
  }
`;
